export default function Hero() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/13056840894', '_blank');
  };

  const handleCalendar = () => {
    window.open('https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Fondo con degradado elegante */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#050505] via-[#1C1C1C] to-[#050505]">
        <div className="absolute inset-0 bg-gradient-to-tr from-[#D4AF37]/10 via-transparent to-[#D4AF37]/5"></div>
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Logo */}
        <div className="mb-12">
          <img 
            src="https://static.readdy.ai/image/79a7f2b53ad81669f992c9be02ef39d3/22016f785dd23e44468347a3990bbdbc.png" 
            alt="Cashflow VIP" 
            className="h-32 md:h-40 mx-auto"
          />
        </div>

        {/* Titular principal */}
        <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Accede a Capital con
          <span className="block text-[#D4AF37] mt-2">0% de Interés Promocional</span>
        </h2>

        {/* Subtítulo */}
        <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-4xl mx-auto leading-relaxed">
          El servicio de Funding es la segunda etapa después de tener un perfil crediticio sólido.
        </p>
        <p className="text-lg md:text-xl text-gray-400 mb-12 max-w-3xl mx-auto">
          Obtén tarjetas personales y de negocio, líneas de crédito y productos bancarios estratégicos para impulsar tu crecimiento.
        </p>

        {/* Botones principales */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
          <button
            onClick={handleCalendar}
            className="group relative px-10 py-5 bg-[#D4AF37] text-[#050505] font-bold text-lg rounded-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/50 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10 flex items-center gap-3">
              <i className="ri-calendar-check-line text-2xl"></i>
              Agenda tu Consulta Gratuita
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>

          <button
            onClick={handleWhatsApp}
            className="px-10 py-5 bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] font-bold text-lg rounded-lg transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#050505] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-3">
              <i className="ri-whatsapp-line text-2xl"></i>
              Escríbenos por WhatsApp
            </span>
          </button>
        </div>

        {/* Enlace a reestructuración de crédito */}
        <div className="mt-8 p-6 bg-[#1C1C1C]/50 border border-[#D4AF37]/20 rounded-lg max-w-2xl mx-auto">
          <p className="text-gray-300 text-base mb-3">
            <i className="ri-information-line text-[#D4AF37] mr-2"></i>
            ¿Tu perfil crediticio aún no está listo para Funding?
          </p>
          <a
            href="https://credit.cashflow.vip/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold hover:text-[#F4D03F] transition-colors duration-300 cursor-pointer"
          >
            Reestructura tu crédito aquí
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Indicador de scroll */}
        <div className="mt-16 animate-bounce">
          <i className="ri-arrow-down-line text-[#D4AF37] text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
